import { AdminType, APIGet, APIPost, APIPut, APIUrl } from "api/protocols";

interface IGetAccommodationBuilding {
  id?: number;
}

export interface IPostAccommodationBuilding {
  title: string;
  code: string;
  description: string;
}

export interface IPutAccommodationBuilding {
  id: number;
  title: string;
  code: string;
  description: string;
}

// GET Accommodation Buildings
export async function GetAccommodationBuildings(params: IGetAccommodationBuilding, useGlobalLoader: boolean) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/accommodation/building"), params, useGlobalLoader);
}

// POST Accommodation Building
export async function PostAccommodationBuilding(params: IPostAccommodationBuilding, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/accommodation/building"), params, useGlobalLoader);
}
// PUT Accommodation Building
export async function PutAccommodationBuilding(params: IPutAccommodationBuilding, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/accommodation/building"), params, useGlobalLoader);
}
